export default __webpack_public_path__ + "static/media/logo_new.ca1c6e11.png";